<div>
  <amplify-authenticator hideSignUp hideForgotPassword></amplify-authenticator>
</div>

<div *ngIf="signedIn == true" id="file-list" class="amplify-authenticator">
  <table class="table table-striped">
    <thead>
      <th>File</th>
      <th>Date</th>
      <th>Size</th>
    </thead>
    <tbody>
      <ng-container *ngFor="let file of files | keyvalue">
        <tr>
          <td>
            <a href={{file.value[1]}} target="_blank">{{file.key.split('/')[file.key.split('/').length - 1]}}</a>
          </td>
          <td>
            <span>{{file.value[0].lastModified | date:'short'}}</span>
          </td>
          <td>
            <span>{{file.value[0].humanSize}}</span>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

</div>